module.exports = __webpack_public_path__ + "static/ThoreauBeta1.9-DisplayRegular-e14df72189794a61958cd9619a4d7f73.woff";